exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".elements__buy--icon i[_v-07a69208] {\n  padding: 5px;\n  cursor: pointer;\n  top: 5px;\n  right: -2px; }\n\n.elements__scrollable-container[_v-07a69208] {\n  max-height: calc(100vh - 100px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: calc(100% + 20px);\n  padding-right: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-07a69208&scoped=true!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=style&index=0!./resources/assets/js/vue/components/menu-cart.vue
// module id = ./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-rewriter.js?id=_v-07a69208&scoped=true!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=style&index=0!./resources/assets/js/vue/components/menu-cart.vue
// module chunks = 0